import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../utils/propUtils';
import VeltActivityLogListDateGroupLabelWireframe from './VeltActivityLogListDateGroupLabelWireframe/VeltActivityLogListDateGroupLabelWireframe';
var VeltActivityLogListDateGroupWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-activity-log-list-date-group-wireframe", __assign({}, transformedProps), children));
};
VeltActivityLogListDateGroupWireframe.Label = VeltActivityLogListDateGroupLabelWireframe;
export default VeltActivityLogListDateGroupWireframe;
